// removed by extract-text-webpack-plugin
module.exports = {"TeamMember":"TeamMember__TeamMember__1-lPc","Person":"TeamMember__Person__-nRJ2","Text":"TeamMember__Text__3x63Y","Image":"TeamMember__Image__JqJhz","Skill":"TeamMember__Skill__37ctI","Skills":"TeamMember__Skills__2c5gS"};


//////////////////
// WEBPACK FOOTER
// ./client/src/components/TeamMember/TeamMember.css
// module id = 420
// module chunks = 0